// https://a.yandex-team.ru/arcadia/taxi/uservices/services/fleet-forms/docs/yaml/api/selfreg.yaml

import { useOnDemandQuery, type UseOnDemandQueryOptions } from "@superweb/api";

import type { ApiRequest, ApiResponse } from "../../api";
import { apiFetch } from "../../fetch";

type UseV1AddressSuggestPostRequest = ApiRequest<
  "/fleet-forms/v1/address/suggest",
  "POST"
>;
type UseV1AddressSuggestPostResponse = ApiResponse<
  "/fleet-forms/v1/address/suggest",
  "POST"
>;

export type UseV1AddressSuggestPostParams = Omit<
  UseV1AddressSuggestPostRequest,
  "method" | "url"
>;

export type UseV1AddressSuggestPostResult =
  | {
      ok: true;
      data: Extract<UseV1AddressSuggestPostResponse, { status: 200 }>["body"];
    }
  | {
      ok: false;
      error: Extract<UseV1AddressSuggestPostResponse, { status: 400 }>["body"];
    };

export const useOnDemandV1AddressSuggestPost = (
  { query, headers, body }: UseV1AddressSuggestPostParams,
  options?: UseOnDemandQueryOptions<UseV1AddressSuggestPostResult>,
) => {
  const url = "/api/fleet-forms/v1/address/suggest";

  return useOnDemandQuery(
    [url, query, headers, body],
    () => {
      const searchParams = new URLSearchParams(query);
      return apiFetch(
        new Request(`${url}?${searchParams.toString()}`, {
          method: "POST",
          headers,
          body: JSON.stringify(body),
        }),
        {
          200: async (r) => ({
            ok: true as const,
            data: (await r.json()) as Extract<
              UseV1AddressSuggestPostResponse,
              { status: 200 }
            >["body"],
          }),
          400: async (r) => ({
            ok: false as const,
            error: (await r.json()) as Extract<
              UseV1AddressSuggestPostResponse,
              { status: 400 }
            >["body"],
          }),
        },
      );
    },
    options,
  );
};
